import type { ReactElement } from 'react';

import { PaymentMethod } from 'models/CurrentUser';
import { PaymentService } from 'config';

import { Component as ApplePayIcon } from 'payment-img/apple-pay/apple-pay-card-icon.svg';
import { Component as GooglePayIcon } from 'payment-img/google-pay/google-pay-card-icon.svg';
import { Component as PaypalIcon } from 'payment-img/paypal/paypal-card-icon.svg';
import { Component as VenmoIcon } from 'payment-img/venmo/venmo-card-icon.svg';
import CardImg from './CardImg';

type Props = { paymentMethod: PaymentMethod; iconClassName: string; };

function PaymentMethod({ paymentMethod, iconClassName }: Props): ReactElement {
  const {
    cc_brand: brand,
    cc_last_four: lastFour,
    customer_email: customerEmail,
    provider_name: provider,
  } = paymentMethod;

  switch (provider) {
    case 'Stripe':
    case PaymentService.CREDIT_CARD:
      return (
        <span>
          <CardImg brand={brand} className={iconClassName} />
          {` ending in ${lastFour}`}
        </span>
      );

    case PaymentService.PAYPAL:
      return (
        <span>
          <PaypalIcon className={iconClassName} />
          {customerEmail}
        </span>
      );

    case PaymentService.GOOGLE_PAY:
      return (
        <span>
          <GooglePayIcon className={iconClassName} />
          Google Pay
        </span>
      );

    case PaymentService.APPLE_PAY:
      return (
        <span>
          <ApplePayIcon className={iconClassName} />
          Apple Pay
        </span>
      );

    case PaymentService.VENMO:
      return (
        <span>
          <VenmoIcon className={iconClassName} />
          Venmo
        </span>
      );

    default:
      return <CardImg brand="unknown" className={iconClassName} />;
  }
}

export default PaymentMethod;
